<template>
  <div class="form-container">
    <div class="header-box">
      <i class="header-icon"></i>
      <!-- <img class="header-img" :src="require('@/assets/imgs/person.png')" /> -->
      <label class="header-name">投保人信息</label>
    </div>
    <div class="idcard-box">
      <div class="carimg-box">
        <div
          class="img-item"
          v-if="$ComTools.isEmptyString(dataForm.urlCardFront)"
          @click="handleUploadClick(1)"
          :style="{
            backgroundImage:
              'url(' + require('@/assets/imgs/upload/id_card_front.png') + ')',
          }"
        ></div>
        <div class="view-item" @click="handleUploadClick(1)" v-else>
          <img :src="imgCardFrontBase64" />
        </div>
        <input
          type="file"
          ref="rfile1"
          @change="handleUploadChange($event, 1)"
          multiple
          style="display: none"
          accept="image/*"
        />
      </div>
      <div class="carimg-box">
        <div
          class="img-item"
          v-if="$ComTools.isEmptyString(dataForm.urlCardVerso)"
          @click="handleUploadClick(2)"
          :style="{
            backgroundImage:
              'url(' + require('@/assets/imgs/upload/id_card_verso.png') + ')',
          }"
        ></div>
        <div class="view-item" @click="handleUploadClick(2)" v-else>
          <img :src="imgCardVersoBase64" />
        </div>
        <input
          type="file"
          ref="rfile2"
          @change="handleUploadChange($event, 2)"
          multiple
          style="display: none"
          accept="image/*"
        />
      </div>
    </div>
    <van-form>
      <van-field
        v-model="dataForm.insureIdNo"
        name="被保人身份证"
        label="被保人身份证"
        placeholder="请输入被保人身份证"
        v-on:input="
          dataForm.insureIdNo = dataForm.insureIdNo.replace(/[^\d|X|x]/g, '')
        "
      />
      <van-field
        v-model="dataForm.insureName"
        name="被保人姓名"
        label="被保人姓名"
        placeholder="被保人姓名"
      />
      <van-field
        v-model="dataForm.engineNo"
        name="发动机号"
        label="发动机号"
        placeholder="请输入发动机号"
      />
      <van-field
        v-model="dataForm.vinNo"
        name="车架号"
        label="车架号"
        placeholder="请输入车架号"
      />
      <van-field
        readonly
        clickable
        name="保险产品"
        label="保险产品"
        :value="productValue"
        placeholder="请选择"
        @click="showProductPicker = true"
      />
      <van-field name="checkbox" label="新车">
        <template #input>
          <van-checkbox v-model="checkbox" shape="square" />
        </template>
      </van-field>
      <div class="header-box" v-if="!checkbox">
        <i class="header-icon"></i>
        <!-- <img class="header-img" :src="require('@/assets/imgs/person.png')" /> -->
        <label class="header-name">行车证信息</label>
      </div>
      <div class="idcard-box" v-if="!checkbox">
        <div class="carimg-box">
          <div
            class="img-item"
            v-if="$ComTools.isEmptyString(dataForm.urlCar)"
            @click="handleUploadClick(3)"
            :style="{
              backgroundImage:
                'url(' +
                require('@/assets/imgs/upload/vehicle_license.png') +
                ')',
            }"
          ></div>
          <div class="view-item" @click="handleUploadClick(3)" v-else>
            <img :src="imgCarBase64" />
          </div>
          <input
            type="file"
            ref="rfile3"
            @change="handleUploadChange($event, 3)"
            multiple
            style="display: none"
            accept="image/*"
          />
        </div>
      </div>
      <div class="header-box" v-if="checkbox">
        <i class="header-icon"></i>
        <!-- <img class="header-img" :src="require('@/assets/imgs/person.png')" /> -->
        <label class="header-name">合格证信息</label>
      </div>
      <div class="idcard-box" v-if="checkbox">
        <div class="carimg-box">
          <div
            class="img-item"
            v-if="$ComTools.isEmptyString(dataForm.urlCertific)"
            @click="handleUploadClick(4)"
            :style="{
              backgroundImage:
                'url(' +
                require('@/assets/imgs/upload/common.png') +
                ')',
            }"
          ></div>
          <div class="view-item" @click="handleUploadClick(4)" v-else>
            <img :src="imgCertificBase64" />
          </div>
          <input
            type="file"
            ref="rfile4"
            @change="handleUploadChange($event, 4)"
            multiple
            style="display: none"
            accept="image/*"
          />
        </div>
      </div>
      <div class="header-box" v-if="checkbox">
        <i class="header-icon"></i>
        <!-- <img class="header-img" :src="require('@/assets/imgs/person.png')" /> -->
        <label class="header-name">发票信息</label>
      </div>
      <div class="idcard-box" v-if="checkbox">
        <div class="carimg-box">
          <div
            class="img-item"
            v-if="$ComTools.isEmptyString(dataForm.urlInvoice)"
            @click="handleUploadClick(5)"
            :style="{
              backgroundImage:
                'url(' +
                require('@/assets/imgs/upload/common.png') +
                ')',
            }"
          ></div>
          <div class="view-item" @click="handleUploadClick(5)" v-else>
            <img :src="imgInvoiceBase64" />
          </div>
          <input
            type="file"
            ref="rfile5"
            @change="handleUploadChange($event, 5)"
            multiple
            style="display: none"
            accept="image/*"
          />
        </div>
      </div>
      <van-cell
        title="保障项目"
        is-link
        @click="showInfo = !showInfo"
        value="点击查看"
        :arrow-direction="showInfo ? 'down' : ''"
      />
    </van-form>
    <div class="productinfo-view" v-show="showInfo">
      <div
        class="productinfo-item"
        v-for="(item, index) in infoOptions"
        :key="index"
      >
        <div class="title">《{{ item.name }}》</div>
        <div class="content-box">
          <div class="left">{{ item.show }}</div>
          <div class="right">
            <div
              class="right-item"
              v-for="(name, idx) in item.contentList"
              :key="idx"
            >
              {{ name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 5rem"></div>
    <div class="button-save">
      <van-button @click="handleGoClick" type="primary" block color="#fe5958"
        >立即投保</van-button
      >
    </div>
    <div class="overlay-box">
      <van-overlay :show="showLoading">
        <div class="wrapper">
          <div class="loadding-box">
            <van-loading type="spinner" color="white" />上传中
          </div>
        </div>
      </van-overlay>
    </div>
    <van-popup v-model="showProductPicker" position="bottom">
      <van-picker
        show-toolbar
        value-key="name"
        :columns="productLists"
        @confirm="handleProductPickerOk"
        @cancel="showProductPicker = false"
      />
    </van-popup>
    <a href="tel:18595961771" v-show="false" ref="tels"></a>
  </div>
</template>

<script>
import switchs from "@/components/switch";
import { isMobile, isCard } from "@/utils/validate";
import {
  uploadIdCard,
  uploadCarCard,
  createMotorInsure,
  getJsapiTicket,
  findCategoryByProductId,
  commonUploadFile,
} from "@/api/common";
import qs from "qs";
import { Notify } from "vant";
import { Dialog } from "vant";
import { Toast } from "vant";
export default {
  components: { switchs },
  data() {
    return {
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(),
      currentDate: "",
      showProductPicker: false,
      showConfirm: false,
      idCardIsUpload: false,
      dataForm: {
        insureIdNo: "",
        insureName: "",
        categoryId: "",
        engineNo: "",
        platformId: "",
        belongerId: "",
        vinNo: "",
        urlCar: "",
        urlCertific: "",
        urlInvoice: "",
        urlCardFront: "",
        urlCardVerso: "",
      },
      imgCardVersoBase64: "",
      imgCardFrontBase64: "",
      imgCarBase64: "",
      imgCertificBase64: "",
      imgInvoiceBase64: "",
      checkbox: false,
      productValue: "",
      showLoading: false,
      productOptions: [],
      productLists: [],
      showInfo: false,
      infoOptions: [],
    };
  },
  created() {
    this.dataForm.belongerId = this.$route.query.belongerId || "";
    this.dataForm.platformId = this.$route.query.platformId || "";
    document.title = "摩托车险";
    this._findCategoryByProductId();
  },
  mounted() {
    let sUrl = location.href.split("#")[0];
    let sImgUrl = "http://nywx.e-ibdt.cn/file/logo/logo_picc.png";
    getJsapiTicket({ appid: process.env.WXKey, url: sUrl }).then((res) => {
      if (res.code === 0) {
        this.$ComTools.wxShare(
          res.data,
          sUrl,
          sImgUrl,
          "摩托车险"
        );
      }
    });
  },
  methods: {
    _findCategoryByProductId() {
      this.productOptions = [];
      this.productLists = [];
      findCategoryByProductId({ productId: 400 }).then((res) => {
        if (res.code == 0) {
          this.productOptions = res.data.list;
          for (let i = 0; i < this.productOptions.length; i++) {
            let oProduct = this.productOptions[i];
            if (this.itemindex == oProduct.id) {
              this.productValue = oProduct.allName;
              this.setValue(oProduct);
            }
            this.productLists.push(this.$ComTools.assertOfDepth(oProduct));
          }
        }
      });
    },
    handleProductPickerOk(a) {
      this.productValue = a.name;
      this.showProductPicker = false;
      this.dataForm.categoryId = a.id;
      let sClauseJson = a.clauseJson;
      if (!this.$ComTools.isEmptyString(sClauseJson)) {
        let aClauseJson = JSON.parse(sClauseJson);
        let aTmp = [];
        for (let i = 0; i < aClauseJson.length; i++) {
          let item = aClauseJson[i];
          let sContent = item.content;
          item.contentList = [];
          if (!this.$ComTools.isEmptyString(sContent)) {
            item.contentList = sContent.split(",");
          }
          aTmp.push(item);
        }
        this.infoOptions = aTmp;
      }
    },
    handleUploadClick(index) {
      switch (index) {
        case 1: //身份证正面
          this.$refs.rfile1.click();
          break;
        case 2: //身份证反面
          this.$refs.rfile2.click();
          break;
        case 3: //行驶证正面
          this.$refs.rfile3.click();
          break;
        case 4: //合格证
          this.$refs.rfile4.click();
          break;
        case 5: //发票
          this.$refs.rfile5.click();
          break;
      }
    },
    handleUploadChange(e, index) {
      let oFile = e.target.files[0];
      let fd = new FormData();
      fd.append("file", oFile);
      Toast.loading({
        message: "上传中...",
        forbidClick: true,
        duration: 0,
      });
      var reader = new FileReader();
      reader.readAsDataURL(oFile);
      reader.onload = (e) => {
        switch (index) {
          case 1: //身份证正面
            this.imgCardFrontBase64 = e.target.result;
            break;
          case 2: //身份证反面
            this.imgCardVersoBase64 = e.target.result;
            break;
          case 3: //行驶证正面
            this.imgCarBase64 = e.target.result;
            break;
          case 4: //合格证
            this.imgCertificBase64 = e.target.result;
            break;
          case 5: //发票
            this.imgInvoiceBase64 = e.target.result;
            break;
        }
      };
      switch (index) {
        case 1: //身份证正面
        case 2: //反面
          uploadIdCard(fd).then((res) => {
            Toast.clear();
            if (index == 1) {
              this.dataForm.urlCardFront = res.data.url;
              let oResult = res.data.result;
              if (!this.$ComTools.isEmptyString(oResult)) {
                this.dataForm.insureIdNo = oResult.number;
                this.dataForm.insureName = oResult.name;
              }
              this.$refs.rfile1.value = null;
            } else {
              this.dataForm.urlCardVerso = res.data.url;
              this.$refs.rfile2.value = null;
            }
          });
          break;
        case 3:
        case 4:
        case 5:
          commonUploadFile(fd).then((res) => {
            Toast.clear();
            switch (index) {
              case 3: //行驶证证
                this.dataForm.urlCar = res.data;
                this.$refs.rfile3.value = null;
                break;
              case 4: //合格证
                this.dataForm.urlCertific = res.data;
                this.$refs.rfile4.value = null;
                break;
              case 5: //发票
                this.dataForm.urlInvoice = res.data;
                this.$refs.rfile5.value = null;
                break;
            }
          });
          break;
      }
    },
    handleCallClick() {
      this.$refs.tels.click();
    },
    handleGoClick() {
      if (this.$ComTools.isEmptyString(this.dataForm.urlCardFront)) {
        return Notify("请上传身份证正面照片");
      }
      if (this.$ComTools.isEmptyString(this.dataForm.urlCardVerso)) {
        return Notify("请上传身份证反面照片");
      }
      if (this.$ComTools.isEmptyString(this.dataForm.insureIdNo)) {
        return Notify("被保人身份证号不能为空");
      }
      if (!isCard(this.dataForm.insureIdNo)) {
        return Notify("被保人身份证格式错误");
      }
      if (this.$ComTools.isEmptyString(this.dataForm.insureName)) {
        return Notify("被保人姓名不能为空");
      }
      if (
        this.$ComTools.isEmptyString(this.dataForm.engineNo) &&
        this.$ComTools.isEmptyString(this.dataForm.vinNo)
      ) {
        return Notify("发动机号和车架号不能同时为空");
      }
      if (this.$ComTools.isEmptyString(this.dataForm.categoryId)) {
        return Notify("请选择产品");
      }
      if (this.checkbox) {
        this.dataForm.type = 1;
        if (this.$ComTools.isEmptyString(this.dataForm.urlCertific)) {
          return Notify("请上传合格证照片");
        }
        if (this.$ComTools.isEmptyString(this.dataForm.urlInvoice)) {
          return Notify("请上传发票照片");
        }
        this.dataForm.urlCar = "";
      } else {
        this.dataForm.type = 0;
        if (this.$ComTools.isEmptyString(this.dataForm.urlCar)) {
          return Notify("请上传行车证照片");
        }
        this.dataForm.urlCertific = "";
        this.dataForm.urlInvoice = "";
      }
      Toast.loading({
        message: "投保中...",
        forbidClick: true,
        duration: 0,
      });
      createMotorInsure(this.dataForm).then((res) => {
        Toast.clear();
        if (res.code === 0) {
          var paymentMap = res.data;
          if (typeof WeixinJSBridge === "undefined") {
            if (document.addEventListener) {
              document.addEventListener(
                "WeixinJSBridgeReady",
                this.$ComTools.onBridgeReady(paymentMap, this.payCallback),
                false
              );
            } else if (document.attachEvent) {
              document.attachEvent(
                "WeixinJSBridgeReady",
                this.$ComTools.onBridgeReady(paymentMap, this.payCallback)
              );
              document.attachEvent(
                "onWeixinJSBridgeReady",
                this.$ComTools.onBridgeReady(paymentMap, this.payCallback)
              );
            }
          } else {
            this.$ComTools.onBridgeReady(paymentMap, this.payCallback);
          }
        } else {
          Notify({ type: "danger", message: res.msg });
        }
      });
    },
    payCallback(index) {
      switch (index) {
        case 1:
          this.$router.push({
            path: "/insure/list",
          });
          break;
        case 2:
          Toast("取消支付");
          WeixinJSBridge.call("closeWindow");
          break;
        case 3:
          Toast("支付失败");
          WeixinJSBridge.call("closeWindow");
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form-container {
  width: 100%;
  min-height: 100%;
  .header-box {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0.8rem;
    .header-icon {
      background-color: #ffc281;
      height: 1.4rem;
      width: 5px;
      display: block;
      margin-right: 0.5rem;
    }
    .header-img {
      width: 1.3rem;
      margin: 0 0.5rem;
    }
    .header-name {
      font-size: 1rem;
      font-weight: 600;
    }
  }
  .idcard-box {
    width: 100%;
    display: flex;
    justify-content: space-around;
  }
  .carimg-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 42%;
    .img-item {
      width: 100%;
      height: 96px;
      border: 1px dashed #d9d9d9;
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      background-size: 100% 100%;
    }
    .view-item {
      width: 100%;
      height: 96px;
      border: 1px dashed #d9d9d9;
      border-radius: 5px;
      overflow: hidden;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
      .option-view {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        i {
          font-size: 20px;
          color: red;
          display: none;
          cursor: pointer;
        }
        &:hover i {
          display: block;
        }
      }
    }
  }
  .button-save {
    /deep/ .van-button {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }
  .overlay-box {
    /deep/ .van-overlay {
      background-color: transparent;
    }
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .loadding-box {
      width: 6rem;
      background-color: rgba(0, 0, 0, 0.7);
      height: 5rem;
      color: white;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      border-radius: 5px;
      padding: 0.6rem 0;
    }
  }
  .productinfo-view {
    padding: 10px 16px;
    .productinfo-item {
      border: 1px solid #e3e1e2;
      border-bottom: none;
      &:first-child {
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
      }
      &:last-child {
        border-bottom: 1px solid #e3e1e2;
        border-bottom-left-radius: 3px;
        border-bottom-right-radius: 3px;
      }
      .title {
        width: 100%;
        text-align: center;
        padding: 8px 0;
        background-color: #f2f2f2;
        font-size: 0.8rem;
        color: #4caaf7;
        border-bottom: 1px solid #e3e1e2;
      }
      .content-box {
        width: 100%;
        // display: flex;
        // align-items: center;
        display: flex;
        .left {
          width: 30%;
          text-align: center;
          font-size: 0.8rem;
          color: #5e5e5e;
          padding: 5px 10px;
          display: flex;
          align-items: center;
        }
        .right {
          width: 70%;
          display: flex;
          flex-direction: column;
          border-left: 1px solid #e3e1e2;
          justify-content: center;
          .right-item {
            text-align: center;
            padding: 10px 0;
            border-bottom: 1px solid #e3e1e2;
            font-size: 0.8rem;
            color: #5e5e5e;
            &:last-child {
              border-bottom: none;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/insurance/motor_form.vue